import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../__root"

/**
 * Document detail -- `/documents/$documentId`.
 *
 * Code-split: the page body (metadata + status + transitions +
 * corrections + attachments upload form) lives in
 * `$documentId.page.tsx` and is loaded lazily via
 * `lazyRouteComponent`. The route stub stays small so it can be
 * pulled into the eager router bundle without dragging the page
 * chunk.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/documents/$documentId",
	component: lazyRouteComponent(() => import("./$documentId.page")),
})
